/* eslint-disable no-unused-vars */
/* eslint-disable node/no-missing-import */
// Copyright (c) 2015-present, salesforce.com, inc. All rights reserved

import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Card from '@salesforce/design-system-react/components/card';
import Input from '@salesforce/design-system-react/components/input';
import Button from '@salesforce/design-system-react/components/button';
import { useIntl } from 'react-intl';
import { LABEL_NEXT, LABEL_RESTORE_TOKEN, MESSAGE_RESTORE_TOKEN_FAILURE } from '../../constants/constants';

// eslint-disable-next-line react/function-component-definition
const TokenValidation = ({ ...props }) => {
	const { validateAccessToken, tokenValidationError, setTokenValidationError } = props;
	const intl = useIntl();

	const [accessTokenErrorMessage, updateAccessTokenErrorMessage] = useState('');
	const [accessToken, accessTokenChanges] = useState('');
	
	const validateAccessTokenResquest = () => {
		// eslint-disable-next-line no-useless-escape
		const regexGuid = /^(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/gi;
		if (regexGuid.test(accessToken)) {
			validateAccessToken(accessToken);
		} else {
			const restoreTokenFailureMessage = intl.formatMessage({
				id: 'TOKEN_FAILURE',
				defaultMessage: MESSAGE_RESTORE_TOKEN_FAILURE
			});

			setTokenValidationError(restoreTokenFailureMessage);
		}
	};

	const restoreTokenLabel = intl.formatMessage({
		id: 'labels.RESTORE_TOKEN',
		defaultMessage: LABEL_RESTORE_TOKEN
	});

	const nextLabel = intl.formatMessage({
		id: 'labels.NEXT',
		defaultMessage: LABEL_NEXT
	});

	return (
		<div className="slds-grid slds-wrap slds-align_absolute-center">
			<div className="slds-col slds-medium-size_3-of-12">
				<Card
					hasNoHeader
				>
					<div className="slds-p-around_small">
						<div className="slds-text-color_error">
							{ tokenValidationError }
						</div>
						<div>
							<Input
								id="restore-token"
								label={restoreTokenLabel}
								onChange={(e) => accessTokenChanges(e.target.value)}
							/>
						</div>
						<div className="slds-p-top_small">
							<Button label={nextLabel} variant="brand" className="max-width" onClick={validateAccessTokenResquest} />
						</div>
					</div>
				</Card>
			</div>
		</div>
	);
};

TokenValidation.propTypes = {
	validateAccessToken: PropTypes.func.isRequired,
	tokenValidationError: PropTypes.string.isRequired,
	setTokenValidationError: PropTypes.func.isRequired
};

export default TokenValidation;
